import { render, staticRenderFns } from "./PatientNorditropinTab.vue?vue&type=template&id=238c0df9&scoped=true&"
import script from "./PatientNorditropinTab.vue?vue&type=script&lang=js&"
export * from "./PatientNorditropinTab.vue?vue&type=script&lang=js&"
import style0 from "./PatientNorditropinTab.vue?vue&type=style&index=0&id=238c0df9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c0df9",
  null
  
)

export default component.exports